<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>操作记录</el-breadcrumb-item>
			<el-breadcrumb-item>账务记录</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div>钱包类型：</div>
				<el-select size="mini" v-model="search.wallet" placeholder="全部类型" style="width: 120px;">
					<el-option key="" label="全部" value=""></el-option>
					<el-option key="1" label="红钻钱包" value="1"></el-option>
					<el-option key="2" label="蓝钻钱包" value="2"></el-option>
				</el-select>
				<div style="margin-left: 10px;">增加扣减：</div>
				<el-select size="mini" v-model="search.action" placeholder="操作类型" style="width: 120px;">
					<el-option key="" label="全部" value=""></el-option>
					<el-option key="add" label="增加" value="add"></el-option>
					<el-option key="sub" label="扣减" value="sub"></el-option>
				</el-select>
				<div style="margin-left: 10px;">操作类型：</div>
				<el-select size="mini" v-model="search.types" placeholder="操作类型" style="width: 120px;">
					<el-option key="" label="全部" value=""></el-option>
					<el-option key="1" label="赠送" value="1"></el-option>
					<el-option key="0" label="其他" value="0"></el-option>
				</el-select>
				<div>&nbsp;&nbsp;搜索：</div>
				<el-input size="mini" placeholder="UID/账号/金额" v-model="search.keyword" style="margin-right: 10px; width:200px;"></el-input>
				<el-button size="mini" type="primary" @click="getData()">搜索</el-button>
				<el-button size="mini" type="warning" @click="reset()">重置</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="id" label="序号" align="center"></el-table-column>
				
				<el-table-column prop="nickname" label="操作员" align="center">
				</el-table-column>
				<el-table-column prop="username" label="会员账号" align="center">
				</el-table-column>
				<el-table-column prop="wallet" label="钱包" align="center">
					<template slot-scope="scope">
						<el-button type="danger" v-if="scope.row.wallet==1" size="mini">红钻账户</el-button>
						<el-button type="primary" v-if="scope.row.wallet==2" size="mini">蓝砖账户</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="操作金额" align="center">
					<template slot-scope="scope">
						<span style="color:red" v-if="scope.row.action=='add'">+{{scope.row.amount}}</span>
						<span  style="color:green" v-if="scope.row.action=='sub'">-{{scope.row.amount}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remarks" label="备注" align="center">
				</el-table-column>
				
				<el-table-column prop="types" label="类型" align="center">
					<template slot-scope="scope">
						<el-button type="danger" v-if="scope.row.types==1" size="mini">赠送</el-button>
						<el-button type="primary" v-if="scope.row.types==0" size="mini">其他</el-button>
					</template>
				</el-table-column>
				
				<el-table-column prop="add_time" label="操作时间" align="center">
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
	</div> 
</template>

<script>
	
	export default {
		computed:{
		},
		data(){
			return {
				search:{
					keyword:'',
					wallet:'',
					action:'',
					types:''
				},
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:10
			}
		},
		created() {
			this.getData();
		},
		methods:{
			reset(){
				this.search = {
					keyword:'',
					wallet:'',
					action:'',
					types:''
				}
				this.getData();
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Record/getRechargeList", {page:this.currentPage, limit:this.limit, ...this.search}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			}
		}
	}
</script>

